module.exports = __webpack_public_path__ + "static/media/final-logo.a13ec5eb.svg";